// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__fGolP","spin":"Loader_spin__p+Ogh"};